// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "transaction.proto" (package "transaction", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TransactionService } from "./transaction";
import type { BatchCreateTransactionsResponse } from "./transaction";
import type { BatchCreateTransactionsRequest } from "./transaction";
import type { DeleteTransactionResponse } from "./transaction";
import type { DeleteTransactionRequest } from "./transaction";
import type { UpdateTransactionResponse } from "./transaction";
import type { UpdateTransactionRequest } from "./transaction";
import type { CreateTransactionResponse } from "./transaction";
import type { CreateTransactionRequest } from "./transaction";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllTransactionsResponse } from "./transaction";
import type { GetAllTransactionsRequest } from "./transaction";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service transaction.TransactionService
 */
export interface ITransactionServiceClient {
    /**
     * @generated from protobuf rpc: GetAllTransactions
     */
    getAllTransactions(input: GetAllTransactionsRequest, options?: RpcOptions): UnaryCall<GetAllTransactionsRequest, GetAllTransactionsResponse>;
    /**
     * @generated from protobuf rpc: CreateTransaction
     */
    createTransaction(input: CreateTransactionRequest, options?: RpcOptions): UnaryCall<CreateTransactionRequest, CreateTransactionResponse>;
    /**
     * @generated from protobuf rpc: UpdateTransaction
     */
    updateTransaction(input: UpdateTransactionRequest, options?: RpcOptions): UnaryCall<UpdateTransactionRequest, UpdateTransactionResponse>;
    /**
     * @generated from protobuf rpc: DeleteTransaction
     */
    deleteTransaction(input: DeleteTransactionRequest, options?: RpcOptions): UnaryCall<DeleteTransactionRequest, DeleteTransactionResponse>;
    /**
     * @generated from protobuf rpc: BatchCreateTransactions
     */
    batchCreateTransactions(input: BatchCreateTransactionsRequest, options?: RpcOptions): UnaryCall<BatchCreateTransactionsRequest, BatchCreateTransactionsResponse>;
}
/**
 * @generated from protobuf service transaction.TransactionService
 */
export class TransactionServiceClient implements ITransactionServiceClient, ServiceInfo {
    typeName = TransactionService.typeName;
    methods = TransactionService.methods;
    options = TransactionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllTransactions
     */
    getAllTransactions(input: GetAllTransactionsRequest, options?: RpcOptions): UnaryCall<GetAllTransactionsRequest, GetAllTransactionsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllTransactionsRequest, GetAllTransactionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateTransaction
     */
    createTransaction(input: CreateTransactionRequest, options?: RpcOptions): UnaryCall<CreateTransactionRequest, CreateTransactionResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateTransactionRequest, CreateTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateTransaction
     */
    updateTransaction(input: UpdateTransactionRequest, options?: RpcOptions): UnaryCall<UpdateTransactionRequest, UpdateTransactionResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateTransactionRequest, UpdateTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteTransaction
     */
    deleteTransaction(input: DeleteTransactionRequest, options?: RpcOptions): UnaryCall<DeleteTransactionRequest, DeleteTransactionResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteTransactionRequest, DeleteTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchCreateTransactions
     */
    batchCreateTransactions(input: BatchCreateTransactionsRequest, options?: RpcOptions): UnaryCall<BatchCreateTransactionsRequest, BatchCreateTransactionsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchCreateTransactionsRequest, BatchCreateTransactionsResponse>("unary", this._transport, method, opt, input);
    }
}
